import React, { createContext, useContext, useEffect, useState } from "react";
import Keycloak from 'keycloak-js';
import Loader from "components/Loader";

const { REACT_APP_KEYCLOAK_URL, REACT_APP_KEYCLOAK_REALM, REACT_APP_KEYCLOAK_CLIENT_ID } = process.env;

export const keycloak = new Keycloak({
  url: REACT_APP_KEYCLOAK_URL,
  realm: REACT_APP_KEYCLOAK_REALM,
  clientId: REACT_APP_KEYCLOAK_CLIENT_ID,
});

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (keycloak.didInitialize) { 
      setInitialized(false)
      return
    } else {
      keycloak.init({
        onLoad: "login-required",
        pkceMethod: "S256",
        flow: "standard",
        enableLogging: true,
        useNonce: true,
      })
      .then((authenticated) => {
        if (authenticated) {
          setInitialized(true);
        } else {
          keycloak.login();
        }
      })
      .catch(() => {
        console.error("failed initiating keycloak")
      });
    }
  }, []);

  if (!initialized) return <Loader />;

  return (
    <AuthContext.Provider
      value={keycloak}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
